<template>
    <div class="related-items">
        <div class="inner" v-if="items && items.length !== 0">
            <h2 class="related-title">Related</h2>
            <Item v-for="item in items" :key="item.id" :item="item" />
        </div>
    </div>
</template>

<script>
import Item from '@/components/Item.vue';

export default {
    name: 'related-items',
    components: {
        Item,
    },
    props: {
        items: {
            type: Array,
            default: [],
        },
        title: {
            type: String,
            default: 'Related',
        },
    },
}
</script>

<style lang="scss">
    .related-items {
        padding: var(--padding) var(--padding-x3);
        background: black;
        overflow: hidden;
        
        .related-title {
            font-size: var(--medium-size);
            color: white;
        }
    }

    body.body-class-ideas {
        .related-items {
            background: var(--gray);

            .col {
                a,a:hover,a:visited,a:active {
                    color: black;
                }
                .ui-button {
                    color: black;
                    border-color: black;
                }
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .related-items {
            padding: var(--padding);
        }
    }
</style>
